import Router from 'vue-router';

interface IDictionary<T> { [key: string]: T; }

export type ParamValue = string | Array<string | null>;

export function flatten (value: ParamValue): string {
	return value instanceof Array ? value.join(' ') : value;
}

export class QueryString {
	private query: IDictionary<string>;

	constructor (private readonly router: Router) {
		this.query = JSON.parse(JSON.stringify(router.currentRoute.query));
	}

	public clear (field: string): QueryString {
		delete this.query[field];
		return this;
	}

	public set (field: string, value: string | number): QueryString {
		this.query[field] = (value || '').toString();
		return this;
	}

	public get (field: string): string {
		return this.query[field];
	}

	public clearAllExcept (field: string): QueryString {
		const current = this.get(field);

		this.query = {};
		this.query[field] = current;

		return this;
	}

	public clearAll (): QueryString {
		this.query = {};
		return this;
	}

	public navigate (): void {
		this.router.push({ query: this.query });
	}

	public replace (): void {
		this.router.replace({ query: this.query });
	}
}
